import { Component, Connect } from '../react';

import { IWindowViewport } from './types';

import MEASURED from './actions/MEASURED';

@Connect(
    null,
    (dispatch: any) => ({
        update: (dim: IWindowViewport) => dispatch(MEASURED(dim)),
    }),
)
export default class WindowComponent extends Component<any, any> {
    private _last: IWindowViewport = { scrollLeft: 0, scrollTop: 0, width: 0, height: 0 };
    private _timer: any;
    private _scrollingElement: Element;

    private queueUpdate = window.requestAnimationFrame
        ? () => {
            if (!this._timer) {
                window.requestAnimationFrame(this.onUpdate);
            }
        }
        : () => {
            if (!this._timer) {
                window.setTimeout(this.onUpdate);
            }
        };

    public componentDidMount() {
        this._scrollingElement = document.scrollingElement || document.documentElement;
        window.addEventListener('load', this.queueUpdate);
        window.addEventListener('resize', this.queueUpdate);
        window.addEventListener('scroll', this.queueUpdate);
        this.onUpdate();
    }
    public componentWillUnmount() {
        window.removeEventListener('load', this.queueUpdate);
        window.removeEventListener('resize', this.queueUpdate);
        window.removeEventListener('scroll', this.queueUpdate);
    }
    public render() {
        return null as any;
    }

    private onUpdate = () => {
        this._timer = null;
        const { _scrollingElement } = this;
        const next = {
            height: window.innerHeight,
            scrollLeft: _scrollingElement.scrollLeft,
            scrollTop: _scrollingElement.scrollTop,
            width: window.innerWidth,
        };
        const last = this._last;
        if (next.scrollTop !== last.scrollTop
            || next.scrollLeft !== last.scrollLeft
            || next.width !== last.width
            || next.height !== last.height) {
            this._last = next;
            this.props.update(next);
        }
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/window/component.tsx